import { Flex, Icon, Link, Text } from '@chakra-ui/react';
import { Section } from '@/components/shared';
import { IoPaperPlaneOutline } from 'react-icons/io5';
import { Trans, useTranslation } from 'react-i18next';
import { ROUTE_PATHS } from '@/constants';
import { PlainLayout } from '../layout';

export const RecoveryPasswordSuccess = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PlainLayout>
      <Section
        containerProps={{ py: 0, gap: { base: 8, md: 16 } }}
        headingProps={{ mt: 0 }}
        id="recovery-password-success-section"
      >
        <Flex
          alignItems="center"
          direction="column"
          gap={6}
          px={{ base: 8, md: 16, xl: 44 }}
          py={{ base: 10, md: 24 }}
        >
          <Icon as={IoPaperPlaneOutline} h={20} w={20} />
          <Text fontSize={{ base: 'h1.base', md: 'h1.mb' }} fontWeight="bold" textAlign="center">
            {t('LOGIN.RECOVER_PASSWORD_CHECK')}
          </Text>
          <Text fontSize={{ base: 'p.base', md: 'p.mb' }} textAlign="center">
            <Trans
              components={{
                url: (
                  <Link
                    color="brand.red.light"
                    fontWeight="bold"
                    href={ROUTE_PATHS.passwordRecover}
                  />
                ),
              }}
              i18nKey={'LOGIN.RECOVER_PASSWORD_CHECK_MESSAGE'}
            />
          </Text>
        </Flex>
      </Section>
    </PlainLayout>
  );
};
